import Header from "../components/Header";
import Hero from "../components/Hero";
import Footer from "../components/Footer";
import Features from "../components/Features";
import Steps from "../components/Steps";
import MidSection from "../components/MidSection";

export default function Home() {
  return (
    <div className="bg-white text-gray-900 font-sans">
      <Header />
      <main>
        <Hero />
        <Features />
        <Steps />
        <MidSection />
      </main>
      <Footer />
    </div>
  );
}
